import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Sidebar from "./Sidebar";
import Header from "./Header";
import HelpDrawer from "./HelpDrawer";
import { getNavigation } from "../config/navigationConfig";

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();
  const location = useLocation();
  const isDashboardPage = location.pathname === "/dashboard";
  const isRepairProjectFormPage =
    location.pathname === "/repair-projects/create" ||
    /^\/repair-projects\/[^/]+\/edit\/?$/.test(location.pathname);
  const isFullWidthPage =
    isDashboardPage ||
    location.pathname.startsWith("/masters/mobilization-costs") ||
    isRepairProjectFormPage;

  const isAdmin = user?.role === "admin" || user?.bridgebudgetRole === "admin";
  const isPlanner =
    user?.role === "planner" || user?.bridgebudgetRole === "planner";
  const navigation = getNavigation({ isAdmin, isPlanner });

  const userNavigation = [{ name: "Your Profile", href: "/profile" }];

  return (
    <div className="h-screen flex overflow-hidden bg-gray-100">
      {/* Sidebar */}
      <Sidebar
        navigation={navigation}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        currentPath={location.pathname}
      />

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden focus:outline-none">
        {/* Header */}
        <Header
          user={user}
          userNavigation={userNavigation}
          setSidebarOpen={setSidebarOpen}
        />

        {/* Page content */}
        <main
          className={`flex-1 relative z-0 overflow-y-auto ${
            isDashboardPage ? "pb-6 pt-0" : "py-6"
          }`}
        >
          <div
            className={
              isFullWidthPage
                ? "w-full px-3 sm:px-4 md:px-5 lg:px-6"
                : "max-w-7xl mx-auto px-4 sm:px-6 md:px-8"
            }
          >
            <Outlet />
          </div>
        </main>
      </div>

      <HelpDrawer />
    </div>
  );
};

export default Layout;
